import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, setAuthToken } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      setAuthToken(data.access_token);
      toast.success("Welcome back, admin");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="absolute top-6 left-6">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-neutral-400 hover:text-[#FFC300]">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to site
        </Link>
      </div>

      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img
            src="/logo.png"
            alt="Black Yellow Taxi 24H"
            className="h-20 w-auto mx-auto mb-6"
          />
          <h1 className="font-display text-3xl lg:text-4xl uppercase font-black tracking-tighter">
            Admin <span className="text-[#FFC300]">Dispatch</span>
          </h1>
          <p className="mt-3 text-sm text-neutral-400">Sign in to manage incoming bookings.</p>
        </div>

        <form onSubmit={submit} className="bg-[#0A0A0A] border border-[#262626] p-8 lg:p-10" data-testid="admin-login-form">
          <label className="block mb-6">
            <div className="flex items-center gap-2 mb-1">
              <Mail className="w-3.5 h-3.5 text-[#FFC300]" />
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-400">Email</span>
            </div>
            <input
              type="email"
              required
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent border-b border-[#262626] focus:border-[#FFC300] py-3 text-white outline-none w-full transition-colors"
              placeholder="admin@blackyellowtaxi.com"
            />
          </label>
          <label className="block mb-8">
            <div className="flex items-center gap-2 mb-1">
              <Lock className="w-3.5 h-3.5 text-[#FFC300]" />
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-400">Password</span>
            </div>
            <input
              type="password"
              required
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent border-b border-[#262626] focus:border-[#FFC300] py-3 text-white outline-none w-full transition-colors"
              placeholder="••••••••"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full inline-flex items-center justify-center gap-3 bg-[#FFC300] text-black font-bold uppercase tracking-widest text-sm px-6 py-4 hover:bg-white disabled:opacity-60 transition-colors"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
